// ─── Bascule — interrupteur thémé (on/off) — Core ────────────────
// Remplace les toggles maison / le <Switch> RN pour un rendu unifié.
//   <Bascule valeur={x} onChange={setX} />
import React from 'react';
import { TouchableOpacity, View, StyleSheet } from 'react-native';
import { useUI } from '../theme/PreferencesUI';

export default function Bascule({ valeur, onChange, disabled = false, accessibilityLabel }) {
  const UI = useUI();
  const on = !!valeur;
  return (
    <TouchableOpacity activeOpacity={0.8} disabled={disabled} accessibilityRole="switch"
      accessibilityState={{ checked: on, disabled }} accessibilityLabel={accessibilityLabel}
      onPress={() => onChange?.(!on)}
      style={[st.piste, { backgroundColor: on ? UI.accent : UI.champBord }, disabled && { opacity: 0.5 }]}>
      <View style={[st.pouce, on && st.pouceOn]} />
    </TouchableOpacity>
  );
}

const st = StyleSheet.create({
  piste: { width: 44, height: 26, borderRadius: 999, padding: 3, justifyContent: 'center' },
  pouce: { width: 20, height: 20, borderRadius: 999, backgroundColor: '#fff' },
  pouceOn: { alignSelf: 'flex-end' },
});
